import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const warningOverlay: SxProps<Theme> = {
	top: '0',
	left: '0',
	position: 'fixed',

	zIndex: '1000',
	width: '100vw',
	height: '100vh',

	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',

	backgroundColor: 'rgba(67, 74, 79, 0.4)',
	padding: '0 1rem 0 1rem',
};

export const warningCardContent: SxProps<Theme> = {
	padding: '2.5rem 0 0 0',
	display: 'inline-flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '2rem',
	boxShadow: '0 8px 32px rgba(0, 0, 0, 0.24)',
	width: '38.5rem',
	borderRadius: '0.5rem',
	backgroundColor: 'backgrounds.white',
};

export const warningCardTextContainer: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
};

export const warningIcon = {
	fill: '#806310',
	height: '40px',
	width: '40px',
	marginBottom: '1.5rem',
};

export const warningCardText: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'center',
	gap: '1rem',
	margin: '0 1rem 0 1rem',
};

export const warningCardActionBar = (isLargeScreen: boolean): SxProps<Theme> => ({
	gap: '0.25rem',
	display: 'flex',
	alignItems: 'center',
	flexDirection: isLargeScreen ? 'row-reverse' : 'column',
	justifyContent: 'center',
	width: '100%',

	padding: '0.5rem 1.25rem',

	borderRadius: '0 0 0.5rem 0.5rem',
	backgroundColor: 'backgrounds.neutral',
});
